/**
 * IOS — ATC upsell popup. Opens on a successful PDP add-to-cart, instead of the drawer.
 * Cards come straight from custom.sh_upsell_popup_produkte_pdp — no colour matching.
 */
(function () {
  var popup = document.querySelector('[data-sh-atc-popup]');
  if (!popup) return;

  var body = document.body;
  var sheet = popup.querySelector('.sh-atc-popup__sheet');
  var lastTrigger = null;
  var lastFocused = null;

  /* State of the line the popup is currently reporting on. */
  var line = { key: '', variantId: 0, quantity: 1 };

  /* ---------- Money (copied from the theme — no shared helper exists) ---------- */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || (window.KROWN && KROWN.settings.shop_money_format) || '{{ amount }}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount + ((window.KROWN && KROWN.settings.iso_code) || '');
    }

    var match = formatString.match(placeholderRegex);
    if (!match) return formatString;

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  /* ---------- Cart ---------- */

  function getCart() {
    return fetch(window.location.origin + '/cart.js', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }).then(function (r) {
      return r.json();
    });
  }

  /** Keep the theme's drawer and header count right. Matters most if UpCart is removed. */
  function syncThemeCart() {
    return fetch('?section_id=helper-cart')
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var form = document.getElementById('AjaxCartForm');
        var subtotal = document.getElementById('AjaxCartSubtotal');

        if (form && doc.getElementById('AjaxCartForm')) {
          form.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
          if (typeof form.ajaxifyCartItems === 'function') form.ajaxifyCartItems();
        }
        if (subtotal && doc.getElementById('AjaxCartSubtotal')) {
          subtotal.innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;
        }

        var count = document.querySelector('#AjaxCartForm [data-cart-count]');
        var total = document.querySelector('#AjaxCartForm [data-cart-total]');
        if (count) {
          document.querySelectorAll('[data-header-cart-count]').forEach(function (elm) {
            elm.textContent = count.textContent;
          });
        }
        if (total) {
          document.querySelectorAll('[data-header-cart-total]').forEach(function (elm) {
            elm.textContent = total.textContent;
          });
        }
      })
      .catch(function () {
        /* header stays stale rather than breaking the popup */
      });
  }

  /* ---------- Rendering ---------- */

  function renderAdded(cart) {
    var wrap = popup.querySelector('[data-sh-atc-added]');
    if (!wrap) return;

    var item = null;
    for (var i = 0; i < cart.items.length; i++) {
      if (line.key && cart.items[i].key === line.key) {
        item = cart.items[i];
        break;
      }
      if (!line.key && line.variantId && cart.items[i].variant_id === line.variantId) {
        item = cart.items[i];
        break;
      }
    }

    if (!item) {
      wrap.hidden = true;
      return;
    }

    line.key = item.key;
    line.variantId = item.variant_id;
    line.quantity = item.quantity;

    var img = wrap.querySelector('[data-sh-atc-added-image]');
    if (img) {
      if (item.image) {
        img.src = item.image.replace(/(\.[a-z]+)(\?|$)/i, '_138x$1$2');
        img.removeAttribute('srcset');
      }
      img.alt = item.product_title || '';
    }

    var title = wrap.querySelector('[data-sh-atc-added-title]');
    if (title) title.textContent = item.product_title || '';

    var meta = wrap.querySelector('[data-sh-atc-added-meta]');
    if (meta) {
      meta.textContent = item.variant_title
        ? popup.dataset.sizeLabel + ': ' + item.variant_title
        : '';
    }

    var price = wrap.querySelector('[data-sh-atc-added-price]');
    if (price) price.textContent = formatMoney(item.final_line_price);

    var value = wrap.querySelector('[data-sh-atc-qty-value]');
    if (value) value.textContent = item.quantity;

    var down = wrap.querySelector('[data-sh-atc-qty-down]');
    if (down) down.disabled = item.quantity <= 1;

    wrap.hidden = false;
  }

  function renderShipping(cart) {
    var wrap = popup.querySelector('[data-sh-atc-shipping]');
    if (!wrap) return;

    var rate = window.Shopify && Shopify.currency && Shopify.currency.rate ? Number(Shopify.currency.rate) : 1;
    var threshold = Math.round(Number(popup.dataset.freeShipping) * rate);
    if (!threshold) {
      wrap.hidden = true;
      return;
    }

    var remaining = threshold - cart.total_price;
    var text = wrap.querySelector('[data-sh-atc-shipping-text]');
    var fill = wrap.querySelector('[data-sh-atc-shipping-fill]');

    if (remaining > 0) {
      if (text) {
        text.textContent = popup.dataset.textRemaining.replace('[amount]', formatMoney(remaining));
      }
      if (fill) fill.style.width = (cart.total_price * 100) / threshold + '%';
    } else {
      if (text) text.textContent = popup.dataset.textReached;
      if (fill) fill.style.width = '100%';
    }

    wrap.hidden = false;
  }

  function renderCta(cart) {
    var cta = popup.querySelector('[data-sh-atc-cart-cta]');
    if (cta) cta.textContent = popup.dataset.textCartCta.replace('[count]', cart.item_count);
  }

  /** Tick state comes from the cart, so a removal made elsewhere clears it. */
  function renderCards(cart) {
    var inCart = {};
    for (var i = 0; i < cart.items.length; i++) {
      inCart[cart.items[i].variant_id] = true;
    }

    popup.querySelectorAll('[data-sh-atc-card]').forEach(function (card) {
      var input = card.querySelector('[data-sh-atc-card-variant]');
      var button = card.querySelector('[data-sh-atc-card-add]');
      var chosen = input && input.value ? Number(input.value) : 0;
      var added = !!(chosen && inCart[chosen]);

      card.classList.toggle('is-added', added);

      if (button) {
        var label = added ? popup.dataset.textAdded : card.dataset.addLabel;
        if (label) button.setAttribute('aria-label', label);
      }
    });
  }

  function render(cart) {
    renderAdded(cart);
    renderShipping(cart);
    renderCta(cart);
    renderCards(cart);
  }

  function refresh() {
    return getCart().then(render);
  }

  /* ---------- Upsell cards ---------- */

  function resetCard(card) {
    var input = card.querySelector('[data-sh-atc-card-variant]');
    var button = card.querySelector('[data-sh-atc-card-add]');

    if (input) input.value = '';
    card.classList.remove('is-added');
    if (button) {
      button.classList.add('disabled');
      button.setAttribute('disabled', 'disabled');
      button.setAttribute('aria-disabled', 'true');
    }
  }

  function bindCards() {
    popup.querySelectorAll('[data-sh-atc-card]').forEach(function (card) {
      var select = card.querySelector('[data-sh-atc-card-size]');
      var input = card.querySelector('[data-sh-atc-card-variant]');
      var button = card.querySelector('[data-sh-atc-card-add]');
      if (button && !card.dataset.addLabel) {
        card.dataset.addLabel = button.getAttribute('aria-label') || '';
      }

      if (select && input && button) {
        select.addEventListener('change', function () {
          input.value = select.value;
          select.classList.toggle('is-selected', !!select.value);

          /* Picking a different size means this is a new add, not the one just made. */
          card.classList.remove('is-added');
          if (card.dataset.addLabel) button.setAttribute('aria-label', card.dataset.addLabel);

          if (select.value) {
            button.classList.remove('disabled');
            button.removeAttribute('disabled');
            button.removeAttribute('aria-disabled');
          } else {
            button.classList.add('disabled');
            button.setAttribute('disabled', 'disabled');
            button.setAttribute('aria-disabled', 'true');
          }
        });
      }

    });
  }

  /* ---------- Quantity ---------- */

  function changeQuantity(quantity) {
    if (!line.key) return;

    var buttons = popup.querySelectorAll('[data-sh-atc-qty-down], [data-sh-atc-qty-up]');
    buttons.forEach(function (b) {
      b.disabled = true;
    });

    fetch(window.location.origin + '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify({ id: line.key, quantity: quantity }),
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (quantity === 0) {
          close();
          return syncThemeCart();
        }
        render(cart);
        refreshCartApp();
        return syncThemeCart();
      })
      .catch(function () {
        refresh();
      })
      .finally(function () {
        buttons.forEach(function (b) {
          b.disabled = false;
        });
        var down = popup.querySelector('[data-sh-atc-qty-down]');
        if (down) down.disabled = line.quantity <= 1;
      });
  }

  /* ---------- Third-party cart drawer (UpCart) ---------- */

  /*
   * UpCart's API is flat globals — `window.UpCart` is NOT it. The hook below normally comes
   * from snippets/sh-atc-cart-intercept.liquid in <head>; this is the fallback install.
   */
  if (!window.__shAtcSkipHooked) {
    window.__shAtcSkipHooked = true;
    window.__shAtcSkipAdd = false;

    (function () {
      var previous = window.upcartShouldSkipAddToCart;
      window.upcartShouldSkipAddToCart = function () {
        if (window.__shAtcSkipAdd) return true;
        if (typeof previous === 'function') {
          try {
            return previous.apply(this, arguments);
          } catch (e) {
            return false;
          }
        }
        return false;
      };
    })();
  }

  function closeCartApp() {
    if (typeof window.upcartCloseCart === 'function') {
      try { window.upcartCloseCart(); } catch (e) {}
    }
  }

  function refreshCartApp() {
    if (typeof window.upcartRefreshCart === 'function') {
      try { window.upcartRefreshCart(); } catch (e) {}
    }
  }

  /** Belt and braces: UpCart opens asynchronously, so re-close while we are on screen. */
  function suppressCartApp() {
    [0, 120, 300, 600, 1000].forEach(function (delay) {
      setTimeout(function () {
        if (!popup.hidden) closeCartApp();
      }, delay);
    });
  }

  /* ---------- Open / close ---------- */

  function focusables() {
    return Array.prototype.slice
      .call(
        sheet.querySelectorAll('a[href], button:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      )
      .filter(function (el) {
        return el.offsetParent !== null;
      });
  }

  function open(detail) {
    detail = detail || {};

    line.key = '';
    line.variantId = Number(detail.variantId) || 0;
    line.quantity = 1;
    lastTrigger = detail.trigger || null;
    lastFocused = document.activeElement;

    popup.querySelectorAll('[data-sh-atc-card]').forEach(resetCard);
    popup.querySelectorAll('[data-sh-atc-card-size]').forEach(function (s) {
      s.selectedIndex = 0;
      s.classList.remove('is-selected');
    });

    var upsells = popup.querySelector('[data-sh-atc-upsells]');
    if (upsells) upsells.hidden = false;

    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    body.classList.add('sh-atc-popup-open');

    var closeBtn = popup.querySelector('.sh-atc-popup__close');
    if (closeBtn) closeBtn.focus();

    suppressCartApp();
    refresh();

    popup.dispatchEvent(new CustomEvent('sh-atc-popup:open', { detail: detail }));
  }

  function close() {
    if (popup.hidden) return;

    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    body.classList.remove('sh-atc-popup-open');

    refreshCartApp();

    var back = lastTrigger || lastFocused;
    if (back && typeof back.focus === 'function') back.focus();
    lastTrigger = null;
    lastFocused = null;

    popup.dispatchEvent(new CustomEvent('sh-atc-popup:close'));
  }

  popup.querySelectorAll('[data-sh-atc-close]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      close();
    });
  });

  document.addEventListener('keydown', function (e) {
    if (popup.hidden) return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      close();
      return;
    }

    if (e.key === 'Tab' || e.keyCode === 9) {
      var items = focusables();
      if (!items.length) return;

      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  var qtyDown = popup.querySelector('[data-sh-atc-qty-down]');
  var qtyUp = popup.querySelector('[data-sh-atc-qty-up]');
  if (qtyDown) {
    qtyDown.addEventListener('click', function () {
      if (line.quantity > 1) changeQuantity(line.quantity - 1);
    });
  }
  if (qtyUp) {
    qtyUp.addEventListener('click', function () {
      changeQuantity(line.quantity + 1);
    });
  }

  bindCards();

  /* ---------- Staying in step with changes made outside the popup ---------- */

  var lastSync = 0;

  /** Re-read the cart, but not more than once every 1.5s. */
  function resync() {
    if (popup.hidden) return;
    var now = Date.now();
    if (now - lastSync < 1500) return;
    lastSync = now;
    refresh();
  }

  /* UpCart loads after this deferred script, so retry until its subscribe calls exist. */
  var cartAppSubscribed = false;

  function subscribeCartApp() {
    if (cartAppSubscribed) return true;

    ['upcartSubscribeCartUpdated', 'upcartSubscribeItemRemoved'].forEach(function (name) {
      if (typeof window[name] !== 'function') return;
      try {
        window[name](resync);
        cartAppSubscribed = true;
      } catch (e) {}
    });

    return cartAppSubscribed;
  }

  (function waitForCartApp(attempt) {
    if (subscribeCartApp() || attempt > 20) return;
    setTimeout(function () {
      waitForCartApp(attempt + 1);
    }, 500);
  })(0);

  /* Safety net: re-read the cart whenever the shopper comes back to the popup. */
  if (sheet) sheet.addEventListener('pointerenter', resync);
  popup.addEventListener('click', resync, true);
  window.addEventListener('focus', resync);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) resync();
  });

  /* Back-button restore can bring the popup back with a stale cart behind it. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && !popup.hidden) refresh();
  });

  /* ---------- Add-to-cart trigger ---------- */

  /** Only the main buy box is ours. Quick buy, related products etc. keep the drawer. */
  function willHandle(form) {
    if (!form || !form.closest) return false;
    if (form.closest('.sh-atc-popup')) return false;
    if (form.closest('.sh-related-products-wrap, quick-buy, .shop-the-look, .sh-configurator')) return false;
    return true;
  }

  /* The theme's 'add-to-cart' event never fires on this store, so we watch the request. */
  var pendingAdd = null;
  var pendingTimer = null;

  /**
   * Record the add and raise the skip flag before UpCart reads it. Driven by CLICK: UpCart
   * cancels the form submit on some pages, so submit is not reliable here.
   */
  function recordAdd(host, form) {
    if (!host || !form) return;

    var card = host.closest('[data-sh-atc-card]');
    if (!card && !willHandle(host)) return;

    window.__shAtcSkipAdd = true;

    var input = form.querySelector('[name="id"]');
    pendingAdd = {
      card: card || null,
      variantId: input ? Number(input.value) : 0,
      trigger: host.querySelector('[type="submit"]'),
    };

    /* A click that never becomes an add must not leave the flag up for a later request. */
    if (pendingTimer) clearTimeout(pendingTimer);
    pendingTimer = setTimeout(function () {
      pendingAdd = null;
      pendingTimer = null;
      window.__shAtcSkipAdd = false;
    }, 5000);
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target || !e.target.closest) return;

      var button = e.target.closest('[name="add"], button[type="submit"], .product--add-to-cart-button');
      if (!button || button.disabled) return;

      var host = button.closest('product-form');
      if (!host) return;

      recordAdd(host, button.closest('form') || host.querySelector('form'));
    },
    true
  );

  /* Second path, for any surface where the theme's submit still runs. */
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      recordAdd(form.closest('product-form'), form);
    },
    true
  );

  /** Called by the head hook once a /cart/add request has completed successfully. */
  window.__shAtcOnAdd = function () {
    var add = pendingAdd;
    pendingAdd = null;

    if (pendingTimer) {
      clearTimeout(pendingTimer);
      pendingTimer = null;
    }

    if (!add) return;

    if (add.card) {
      /* Added from one of our own upsell cards — keep the popup open. */
      add.card.classList.add('is-added');

      var addedButton = add.card.querySelector('[data-sh-atc-card-add]');
      if (addedButton && popup.dataset.textAdded) {
        addedButton.setAttribute('aria-label', popup.dataset.textAdded);
      }
      /* UpCart reads the flag ~1s after the add, so hold it. The CTA is the way to the cart. */
      suppressCartApp();
      refreshCartApp();
      refresh();

      setTimeout(function () {
        window.__shAtcSkipAdd = false;
      }, 1500);
      return;
    }

    open({
      variantId: add.variantId,
      trigger: add.trigger,
    });

    refreshCartApp();

    /* Release the skip once UpCart has finished reacting to this add. */
    setTimeout(function () {
      window.__shAtcSkipAdd = false;
    }, 1500);
  };

  window.SHAtcPopup = {
    open: open,
    closeCartApp: closeCartApp,
    refreshCartApp: refreshCartApp,
    close: close,
    refresh: refresh,
    willHandle: willHandle,
  };
})();
